import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle, MessageCircle } from "lucide-react";
import { PRODUCTS } from "../../data/content";
import { SITE } from "../../lib/site";

export default function QuoteForm({ sourcePage = "/", compact = false }) {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ full_name: "", company: "", email: "", phone: "", product_type: "", quantity: "", size: "", security_requirement: "", message: "" });

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.full_name || !form.phone) {
      toast.error("Please add your name and phone / WhatsApp number.");
      return;
    }
    const lines = [
      "Hologram Sticker Quote Request",
      "",
      `Name: ${form.full_name}`,
      form.company && `Company: ${form.company}`,
      form.email && `Email: ${form.email}`,
      `Phone: ${form.phone}`,
      form.product_type && `Product: ${form.product_type}`,
      form.quantity && `Quantity: ${form.quantity}`,
      form.size && `Size: ${form.size}`,
      form.security_requirement && `Security: ${form.security_requirement}`,
      form.message && `Details: ${form.message}`,
    ].filter(Boolean);
    const url = `${SITE.whatsapp}?text=${encodeURIComponent(lines.join("\n"))}`;
    window.open(url, "_blank", "noopener");
    setSent(true);
    toast.success("Opening WhatsApp with your enquiry.");
  };

  if (sent) {
    return (
      <div className="card p-10 text-center" data-testid="quote-success">
        <CheckCircle className="mx-auto text-holo-cyan mb-5" size={40} />
        <h3 className="font-head text-2xl font-bold mb-3">Thank you.</h3>
        <p className="text-[#8A8A9B] max-w-md mx-auto">Your enquiry has been prepared in WhatsApp — just press send. Our team will review your requirements and contact you shortly.</p>
        <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="btn-ghost inline-flex items-center gap-2 px-6 py-3 mt-6 text-xs" data-testid="quote-success-whatsapp">
          <MessageCircle size={15} /> Open WhatsApp Again
        </a>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="card p-6 md:p-8 space-y-4" data-testid="quote-form">
      <div className="grid md:grid-cols-2 gap-4">
        <input className="field" placeholder="Full Name *" value={form.full_name} onChange={set("full_name")} data-testid="quote-full-name" />
        <input className="field" placeholder="Company Name" value={form.company} onChange={set("company")} data-testid="quote-company" />
        <input className="field" type="email" placeholder="Email" value={form.email} onChange={set("email")} data-testid="quote-email" />
        <input className="field" placeholder="Phone / WhatsApp *" value={form.phone} onChange={set("phone")} data-testid="quote-phone" />
        <select className="field" value={form.product_type} onChange={set("product_type")} data-testid="quote-product-type">
          <option value="">Product Type</option>
          {PRODUCTS.map((p) => <option key={p.slug} value={p.name}>{p.name}</option>)}
          <option value="Other">Other</option>
        </select>
        <input className="field" placeholder="Quantity" value={form.quantity} onChange={set("quantity")} data-testid="quote-quantity" />
        {!compact && <input className="field" placeholder="Required Size" value={form.size} onChange={set("size")} data-testid="quote-size" />}
        {!compact && <input className="field" placeholder="Security Requirement" value={form.security_requirement} onChange={set("security_requirement")} data-testid="quote-security" />}
      </div>
      <textarea className="field min-h-[120px]" placeholder="Message / project details" value={form.message} onChange={set("message")} data-testid="quote-message" />
      <button type="submit" className="btn-primary w-full py-4 text-sm flex items-center justify-center gap-2" data-testid="quote-submit">
        <MessageCircle size={16} /> Request Quote via WhatsApp
      </button>
      <p className="text-xs text-[#555566] font-mono2 text-center">Fields marked * are required · Opens WhatsApp with your details</p>
    </form>
  );
}
